// Lápis que aparece ao passar o mouse num item editável (o pai precisa da classe "group").
function EditHintIcon({ className = '' }) {

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
            className={`w-[14px] h-[14px] shrink-0 text-gray-400 opacity-0 group-hover:opacity-100 transition-opacity ${className}`}
        >
            <path d="M12 20h9" />
            <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4Z" />
        </svg>
    )
}

export default EditHintIcon
